import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import * as echarts from 'echarts'
import {
  MonthLabelData,
  revenueInfo,
} from '../../util/testData/testCustomerRevenue'

interface Props {
  width?: string
  height?: string
  beforeCharge: number[] | undefined
  afterCharge: number[] | undefined
  recRevenue?: number[] | undefined
  custProfit: number[] | undefined
}

interface WrapperProps {
  height?: string
  width?: string
  fontSize?: string
}

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: ${(props) => (props.height ? props.height : '100%')};
  width: ${(props) => (props.width ? props.width : '100%')};
  padding: 0;
  flex-shrink: 0;
`
export const RevenueBarGraph = (props: Props) => {
  const { width, height, afterCharge, beforeCharge, recRevenue, custProfit } =
    props
  const TempData = revenueInfo
  const MonthLabel = MonthLabelData
  const hasRecRevenue =
    Array.isArray(recRevenue) && recRevenue.some((value) => Number(value) !== 0)

  const chartRef = useRef<echarts.ECharts | null>(null)
  const chartId = useRef(`chart-${Math.floor(Math.random() * 1000000)}`)

  useEffect(() => {
    const chartDom = document.getElementById(chartId.current)
    if (chartDom) {
      if (chartRef.current) {
        chartRef.current.dispose()
      }
      const chart = echarts.init(chartDom)
      const recRevenueSeries: echarts.BarSeriesOption[] = hasRecRevenue
        ? [
            {
              name: '예상 REC 수익',
              type: 'bar',
              stack: 'afterRevenue',
              emphasis: {
                focus: 'series',
              },
              data: recRevenue,
            },
          ]
        : []

      const option: echarts.EChartsOption = {
        tooltip: {
          trigger: 'axis',
        },
        // toolbox: {
        //   show: true,
        //   orient: 'vertical',
        //   left: 'right',
        //   top: 'center',
        //   feature: {
        //     mark: { show: true },
        //     dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ['line', 'bar'] },
        //     restore: { show: true },
        //     saveAsImage: { show: true },
        //   },
        // },
        legend: {
          data: hasRecRevenue
            ? [
                '기존 수익',
                'ESS 사업자와 거래 후',
                '예상 REC 수익',
                '고객 이익',
              ]
            : ['기존 수익', 'ESS 사업자와 거래 후', '고객 이익'],
        },
        grid: {
          left: '5%', // 왼쪽 여백
          right: '5%', // 오른쪽 여백
          top: '10%', // 위쪽 여백
          bottom: '5%', // 아래쪽 여백
          containLabel: true, // 라벨 포함 여부
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            data: MonthLabel,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: '기존 수익',
            type: 'bar',
            barGap: 0,
            emphasis: {
              focus: 'series',
            },
            data: beforeCharge,
          },
          {
            name: 'ESS 사업자와 거래 후',
            type: 'bar',
            stack: hasRecRevenue ? 'afterRevenue' : undefined,
            emphasis: {
              focus: 'series',
            },
            data: afterCharge,
          },
          ...recRevenueSeries,
          {
            name: '고객 이익',
            type: 'bar',
            emphasis: {
              focus: 'series',
            },
            data: custProfit,
          },
        ],
      }
      chart.setOption(option)
      chartRef.current = chart

      return () => {
        if (chartRef.current) {
          chartRef.current.dispose()
        }
      }
    }
  }, [beforeCharge, afterCharge, recRevenue, custProfit, hasRecRevenue])

  return (
    <Wrapper height={height} width={width}>
      <div id={chartId.current} style={{ height: height, width: width }} />
    </Wrapper>
  )
}
